import { useContext } from 'react';
import { ScreenShotContext } from '../../components/ScreenShotProvider/ScreenShotProvider';

export default function useScreenShotContext() {
  const context = useContext(ScreenShotContext);
  if (!context) {
    throw new Error('useScreenShotContext must be used within a NoteProvider');
  }
  return context;
}
